import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePanic } from '../contexts/PanicContext';
import { Home, BookOpen, AlertCircle, User, Heart } from 'lucide-react';

const navItems = [
  { path: '/dashboard', icon: Home, label: 'Home' },
  { path: '/conditions', icon: BookOpen, label: 'Conditions' },
  { path: 'panic', icon: AlertCircle, label: 'Panic', isPanic: true },
  { path: '/resources', icon: Heart, label: 'Resources' },
  { path: '/profile', icon: User, label: 'Profile' }
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { triggerPanic, isPanicMode } = usePanic();

  const hiddenPaths = ['/', '/auth', '/about'];
  if (hiddenPaths.includes(location.pathname) || !isAuthenticated || isPanicMode) {
    return null;
  }

  const handleNavClick = (item) => {
    if (item.isPanic) {
      triggerPanic('workplace');
    } else {
      navigate(item.path);
    }
  };

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-border z-40 pb-[env(safe-area-inset-bottom)]"
      data-testid="bottom-nav"
    >
      <div className="max-w-lg mx-auto flex items-center justify-around py-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path === '/conditions' && location.pathname.startsWith('/disclosure-card'));
          const Icon = item.icon;
          
          return (
            <button
              key={item.label}
              onClick={() => handleNavClick(item)}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={`flex flex-col items-center py-2 px-3 rounded-lg transition-colors ${
                item.isPanic 
                  ? 'text-accent' 
                  : isActive 
                    ? 'text-primary' 
                    : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Icon className={`h-5 w-5 ${item.isPanic ? 'animate-pulse-slow' : ''}`} />
              <span className={`text-[10px] mt-1 font-medium ${item.isPanic ? 'text-accent' : ''}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
